import React from 'react';
import { Rate } from 'tea-component';
import { reviewsFormat, scoreFormat } from '@op/utils/value';
import ChannelLabel from '@op/components/ChannelLabel';
import { useIntl } from 'umi';
import './index.scss';

function StarElement({ review, score, channel, formatMessage,title }: any) {
  return (
    <div className="gamestore-ratings-card">
      <div className="gamestore-ratings-card-content">
        <div className="gamestore-ratings-card-img">
          <ChannelLabel channel_name={channel} showText={false}></ChannelLabel>
        </div>
        <div className="gamestore-ratings-card-value star-value">
          {scoreFormat(score)}
        </div>
      </div>
      <div className="dbo-scorebox-reviewbox">
        <Rate
          readonly
          allowHalf
          theme="primary"
          defaultValue={score}
          size="m"
        />
        <div className="bubble-common-child-wrapper no-pointer">
          <div className="dbo-scorebox-text">
            {reviewsFormat(review, 2, '0')} {formatMessage({ id: title })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Ratings({ renderList = [] }: any) {
  const { formatMessage } = useIntl();

  return (
    <div className="dbo-metrics-gamestore-ratings">
      {renderList?.map((item: { channel: string; formatMessageId: string; }) => (
        <StarElement
          key={item.channel}
          {...item}
          formatMessage={formatMessage}
          title={item.formatMessageId || 'Reviews-1'}
        ></StarElement>
      ))}
    </div>
  );
}